import { Component, EventEmitter, Input, Output, OnInit, Inject, AfterViewInit, AfterContentInit } from 'ng-metadata/core';
import './content-stream.scss';
import * as angular from 'angular';


/**
 * @ngdoc directive
 * @name mwContentStream
 * @module mw.components.contentStream
 *
 * @param {boolean} [is-loading=false] - Control if the content stream is in a loading state.
 * @param {boolean} [is-selectable=false] - Control if the content stream is in selectable.
 * @param {boolean} [is-avatar-padding-on=false] - Control if the content stream avatar padding is on.
 * @param {boolean} [is-loading-more=false] - Control if the content stream is in a loading state.
 * @param {boolean} [show-load-more=false] - Control if the content stream is in a loading state.
 * @param {string} [display-mode='standard'] - The display mode the content stream is on.  Supported values 'standard'(default), 'compact', mini', 'list', 'indy'
 *
 * @description
 * `<md-content-stream>` is a component used to display a collection of content documents.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 *      <mw-content-stream is-loading="$ctrl.isLoading" is-empty="$ctrl.state === 'noresults' || $ctrl.state === 'error'" is-selectable="$ctrl.isSelectable">
 *          <mw-content-stream-body>
 *               <mw-media-document ...>
 *               </mw-media-document>
 *          </mw-content-stream-body>
 *      </mw-content-stream>
 * </hljs>
 */
@Component({
    selector: 'mw-content-stream',
    template: `
        <div class="mw-content-stream mw-content-stream--{{$ctrl.displayMode}}" ng-class="{'mw-content-stream--loading': $ctrl.isLoading || $ctrl.isEmpty}">
            <ng-transclude ng-transclude-slot="mwContentStreamSelector" class="mw-content-stream-header"></ng-transclude>
            <ng-transclude ng-transclude-slot="mwContentStreamHeader" class="mw-content-stream-header"></ng-transclude>
            <ng-transclude ng-transclude-slot="mwContentStreamBody"></ng-transclude>
            <mw-content-document-placeholder ng-if="$ctrl.isLoading || $ctrl.showLoadMore" is-selectable="$ctrl.isSelectable" is-avatar-padding-on="$ctrl.isAvatarPaddingOn" display-mode="$ctrl.displayMode"></mw-content-document-placeholder>
            <mw-content-document-placeholder ng-if="$ctrl.isLoading" is-selectable="$ctrl.isSelectable" is-avatar-padding-on="$ctrl.isAvatarPaddingOn" display-mode="$ctrl.displayMode"></mw-content-document-placeholder>
            <mw-content-document-placeholder ng-if="$ctrl.isLoading" is-selectable="$ctrl.isSelectable" is-avatar-padding-on="$ctrl.isAvatarPaddingOn" display-mode="$ctrl.displayMode"></mw-content-document-placeholder>
        </div>
    `,
    legacy: {
        transclude: {
            'mwContentStreamSelector': '?mwContentStreamSelector',
            'mwContentStreamHeader': '?mwContentStreamHeader',
            'mwContentStreamBody': '?mwContentStreamBody',
        }
    }
})

export class ContentStreamComponent implements OnInit {
    @Input('<') contentContainerId: string; // not used
    @Input('<') displayMode: string = 'standard'; // Supported values 'standard'(default), 'compact', mini', 'list', 'indy'
    @Input('<') isLoading: boolean = false;
    @Input('<') isBusy: boolean = false; // not used
    @Input('<') isSelectable: boolean;
    @Input('<') isAvatarPaddingOn: boolean;
    @Input('<') isEmpty: boolean = false;
    @Input('<') isLoadingMore: boolean = false;
    @Input('<') showLoadMore: boolean = false;

    constructor(
        @Inject('$element') private $element) {
        'ngInject';
    }

    ngOnInit() {
        this.displayMode = this.displayMode ? this.displayMode : 'standard';
        this.isEmpty = this.isEmpty === true ? true : false;
        this.isLoading = this.isLoading === true ? true : false;
        this.isLoadingMore = this.isLoadingMore === true ? true : false;
        this.isSelectable = this.isSelectable === false ? false : true;
        this.showLoadMore = this.showLoadMore === true ? true : false;
    }

    scrollDocumentIntoView(documentElement: HTMLElement) {
        let scrollContainer = this.$element[0].closest('md-content');

        if (documentElement && scrollContainer) {
            documentElement = documentElement.closest('mw-media-document, mw-media-contact-document');
            let documentElementOffsetTop = documentElement.offsetTop;
            let headerElement = this.$element[0].getElementsByTagName('mw-content-stream-header')[0];

            if (headerElement) {
                let headerHeight = headerElement.clientHeight;
                documentElementOffsetTop -= headerHeight;
            }

            // If the top of the document is not in the visible scrollable viewport, reset scroll top
            if (documentElementOffsetTop < scrollContainer.scrollTop) {
                scrollContainer.scrollTop = documentElementOffsetTop;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/content-stream.component.ts